import { DataModel } from "@toolpad/core/Crud";

import { IVehicleDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";
import { DropdownOdata } from "../components/DropdownOdata";

type VehicleDtoDataModel = IVehicleDto & DataModel;

export default function VehiclesPages() {
  const columns: MagicCrudFields<IVehicleDto>[] = [
    {
      field: nameof<IVehicleDto>("id"),
      type: "number",
      extraType: "guid",
    },

    {
      field: nameof<IVehicleDto>("vcuUid"),
      type: "string",
      isRequired: true,
    },
    {
      field: nameof<IVehicleDto>("name"),
      type: "string",
      notInCreateMode: true,
    },
    {
      field: nameof<IVehicleDto>("serialNumber"),
      type: "string",
    },
    {
      field: nameof<IVehicleDto>("hasTrackerIoT"),
      type: "boolean",
    },
    {
      field: nameof<IVehicleDto>("model"),
      type: "custom",
      isRequired: true,
      renderCell: (p) => {
        return <span>{p.value.Name}</span>;
      },
      renderFormField: ({ value, onChange, error }) => {
        return (
          <DropdownOdata
            url="vehicle-models"
            fieldNameId="id"
            fieldNameDescription="name"
            value={(value as any)?.id ?? value}
            onChange={onChange}
            error={error}
            label="model"
            initSelected={value}
            isRequired={true}
          />
        );
      },
    },
    {
      field: nameof<IVehicleDto>("groupId"),
      type: "string",
      extraType: "guid",
      notInCreateMode: true,
    },
    {
      field: nameof<IVehicleDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<VehicleDtoDataModel>
      name="vehicle"
      apiUrl="vehicles"
      columns={columns}
      appUrl="/vehicles"
      trasformDataForServer={(d) => ({
        ...d,
        modelId: d.model?.id ?? d.model,
      })}
    />
  );
}
